module.exports = __webpack_public_path__ + "static/img/ad-zhinengtuijian.018028df.png";